import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

const IconFilterMinus = createReactComponent('outline', 'filter-minus', 'FilterMinus', __iconNode);

export default IconFilterMinus;